import { type ProgramInclusion } from 'ProgramInclusion';
import { type TuitionPlan, TuitionPlanFrequency } from './index';

const baseTuition = 24750;

export const oneTimePlan = {
    id: 'fafbb357-1dde-51d8-b5c8-24835ee34023',
    baseTuition,
    name: `$${baseTuition} with one-time payment discount`,
    tag: 'EMBA76+,MBA76+',
    frequency: TuitionPlanFrequency.Once,
    numIntervals: 1,
} as TuitionPlan;

export const annualPlan = {
    id: '35c0f861-a611-5ef5-b5ee-33dadd7bd389',
    baseTuition,
    name: `$${baseTuition} with annual payment plan`,
    tag: 'EMBA76+,MBA76+',
    frequency: TuitionPlanFrequency.Annual,
    numIntervals: 2,
} as TuitionPlan;

export const monthlyPlan = {
    id: '2450df42-37d8-5342-bf4f-438801ed2495',
    baseTuition,
    name: `$${baseTuition} with monthly payment plan`,
    tag: 'EMBA76+,MBA76+',
    frequency: TuitionPlanFrequency.Monthly,
    numIntervals: 15,
} as TuitionPlan;

export const monthlyExtendedPlan = {
    id: '627e6304-ace1-5ebf-9a6f-d9bb94e41533',
    baseTuition,
    name: `$${baseTuition} with monthly extended payment plan`,
    tag: 'EMBA76+,MBA76+',
    frequency: TuitionPlanFrequency.MonthlyExtended,
    numIntervals: monthlyPlan.numIntervals! * 2,
} as TuitionPlan;

export const fullScholarshipPlan = {
    id: '8bab606f-6c7c-56f7-91d5-f877653e9198',
    baseTuition,
    name: 'Full Scholarship',
    tag: 'EMBA76+,MBA76+',
    frequency: TuitionPlanFrequency.FullScholarship,
    numIntervals: null,
} as TuitionPlan;

export const getStubTuitionPlanForProgramInclusion = (programInclusion: ProgramInclusion): TuitionPlan => {
    const tuitionPlan = [oneTimePlan, annualPlan, monthlyPlan, fullScholarshipPlan].find(
        tp => tp.id === programInclusion.tuitionPlanId,
    );

    if (!tuitionPlan) {
        throw new Error(
            `Stub tuition plan not found for program inclusion with tuition plan ID ${programInclusion.tuitionPlanId}`,
        );
    }

    return tuitionPlan;
};

export const threeTuitionPlans = [oneTimePlan, annualPlan, monthlyPlan];
